import { Tooltip, TooltipContent, TooltipTrigger } from "../../../../components/Tooltip/Tooptip";
import { getTimeOnly } from "../../../../utils/datetime_formats";

export default function UnmatchedPhotos({ unmatchedPhotos, onPhotoClick }) {
    const buildUnmatchedPhotos = () => {
        var imageList = []

        return <div className="flex -space-x-1 overflow-hidden">
            {
                unmatchedPhotos.map((photo, index) => {
                    imageList.push(
                        <Tooltip key={photo.id}>
                            <TooltipTrigger>
                                <img
                                    className="inline-block h-6 w-6 rounded-full ring-2 ring-white hover:cursor-pointer hover:h-7 hover:w-7 hover:ring-gray"
                                    src={photo.thumbnail}
                                    alt=""
                                    onClick={() => onPhotoClick(index)}
                                />
                            </TooltipTrigger>
                            <TooltipContent>
                                <div className="bg-gray-100 px-2 rounded">
                                    <div>촬영시각: {getTimeOnly(photo.taken_at)}</div>
                                    <div>파일명: {photo.filename || "정보없음"}</div>
                                </div>
                            </TooltipContent>
                        </Tooltip>
                    )
                    return null;
                })
            }
            {imageList}
        </div>
    }

    return (
        <>
            <p>미분류 사진</p>
            {buildUnmatchedPhotos()}
        </>
    )
}